<div class="ega xs-hide text-primary">
    <div class="d-none d-md-block">
      <strong>&copy; {{ currentYear }} </strong>
      <strong>Publiic School Management Information System</strong>
    </div>
    <div>
      <strong class="d-none d-md-block">
        The system is designed and developed by
      </strong>
      <a
        href="http://ega.go.tz"
        target="_blank"
        title="e-Government Authority"
      >
        <span class="d-md-none position-relative" style="top: 2px !important">
          <strong class="pr-2">&copy; {{ currentYear }} </strong> | &nbsp;
        </span>
        <img alt="eGA" src="/assets/images/ega.png"/>
      </a>
    </div>
    </div>